import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export async function getUserPlants({
  userId,
}: {
  userId?: string;
}): Promise<{ plantIds: string[] } | undefined | never> {
  if (!userId) return undefined;

  try {
    const { data } = await client.get(`/users/${userId}/plants`);

    return data.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetUserPlantsQuery = (
  { userId, enabled }: { userId?: string; enabled?: boolean } = {
    userId: undefined,
    enabled: true,
  }
) => {
  return useQuery({
    queryKey: ['users', userId, 'plants'],
    queryFn: () => getUserPlants({ userId }),
    retry: 1,
    enabled,
  });
};
